var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector57X2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,8C10,5.878 10.843,3.843 12.343,2.343C13.843,0.843 15.878,0 18,0C20.122,0 22.157,0.843 23.657,2.343C25.157,3.843 26,5.878 26,8C26,10.122 25.157,12.157 23.657,13.657C22.157,15.157 20.122,16 18,16C15.878,16 13.843,15.157 12.343,13.657C10.843,12.157 10,10.122 10,8ZM10,20C7.348,20 4.804,21.054 2.929,22.929C1.054,24.804 0,27.348 0,30C0,31.591 0.632,33.117 1.757,34.243C2.883,35.368 4.409,36 6,36L30,36C31.591,36 33.117,35.368 34.243,34.243C35.368,33.117 36,31.591 36,30C36,27.348 34.946,24.804 33.071,22.929C31.196,21.054 28.652,20 26,20L10,20Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    fill: "#2D2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector57X2);
export default __webpack_public_path__ + "static/media/vector_57_x2.1561ad303d1d2434478763d9c3d35061.svg";
export { ForwardRef as ReactComponent };